import HipImage from "../images/evaluated/mop_hip.svg";
import KneeImage from "../images/evaluated/mop_knee.svg";
import ShoulderImage from "../images/evaluated/mop_shoulder.svg";
import HandImage from "../images/evaluated/mop_hand.svg";
import FootImage from "../images/evaluated/mop_foot.svg";
import Back from "../images/evaluated/mop_back.svg";
import Neck from "../images/evaluated/mop_neck.svg";
import Elbow from "../images/evaluated/mop_elbow.svg";

export const ProvidersListV4 = [
  { value: "orthopedic_surgeon", label: "Orthopedic Surgeon" },
  { value: "chiropractor", label: "Chiropractor" },
  { value: "physical_therapist", label: "Physical Therapist" },
  {
    value: "neurosurgeon_and_spine_specialist",
    label: "Neurosurgeon and Spine Specialist",
  },
  { value: "orthopedic_spine_surgeon", label: "Orthopedic Spine Surgeon" },
];

export const DentalProvidersListV4 = [
  { value: "dentist", label: "Dentist" },
  { value: "oral_surgeon", label: "Oral Surgeon" },
  { value: "periodontist", label: "Periodontist" },
  { value: "orthodontist", label: "Orthodontist" },
  { value: "endodontist", label: "Endodontist" }
];

export const header = [
  { text: "Symptom Checker", to: "evaluation" },
  { text: "Education Library", to: "education" },
  { text: "Find a Provider", to: "providers" },
  { text: "Exercises", to: "exercises" },
];

export const RemoveIntercomSettings = () => {
  setTimeout(() => {
    const appId = window.intercomSettings.app_id;
    if (appId) {
      window.Intercom("boot", {
        app_id: appId,
        email: "",
        name: "",
        user_id: "",
      });
    }
  }, 2000);
};

export const bookAnAppointmentText =
  "Your selected provider is not receiving online appointment request at this time. Please contact your selected provider at ";

export const SetIntercomSettings = () => {
  setTimeout(() => {
    const mopUser = localStorage.getItem("mop-user");
    if (mopUser) {
      const userInfo = JSON.parse(localStorage.getItem("mop-user"));
      if (userInfo) {
        const appId = window.intercomSettings.app_id;
        if (appId) {
          window.intercomSettings = {
            app_id: appId,
            name: userInfo.name,
            email: userInfo.email,
            user_id: userInfo.id,
            role: userInfo.role,
          };
          window.Intercom("boot", {
            app_id: appId,
            name: userInfo.name,
            email: userInfo.email,
            user_id: userInfo.id,
            role: userInfo.role,
          });
        }
      }
    }
  }, 2000);
};

export const MuscleTypes = [
  { name: "Knee", image: KneeImage, slug: "knee", bodyPart: "knee" },
  {
    name: "Shoulder",
    image: ShoulderImage,
    slug: "shoulder",
    bodyPart: "shoulder",
  },
  {
    name: "Hand & Wrist",
    image: HandImage,
    slug: "hand_wrist",
    bodyPart: "hand_and_wrist",
  },
  {
    name: "Foot & Ankle",
    image: FootImage,
    slug: "foot_ankle",
    bodyPart: "foot_and_ankle",
  },
  { name: "Back", image: Back, slug: "back", bodyPart: "back" },
  { name: "Neck", image: Neck, slug: "neck", bodyPart: "neck" },
  { name: "Hip", image: HipImage, slug: "hip", bodyPart: "hip" },
  { name: "Elbow", image: Elbow, slug: "elbow", bodyPart: "elbow" },
];

export const ratingOptions = [
  { label: "1 * Minimum", value: "1" },
  { label: "2 * Minimum", value: "2" },
  { label: "3 * Minimum", value: "3" },
  { label: "4 * Minimum", value: "4" },
  { label: "5 * Minimum", value: "5" },
];
